import React from "react";
import HeaderComponent from "./HeaderComponent";
import ActivationTypeForm from "./Forms/ActivationTypeForm";

const ActivationType = () => {
  return (
    <div className="customerinformation">
      <HeaderComponent />
      <div className="container content ">
        <div>
          <p className="alertemailtet">
            If you facing any issue while activating..Please email to
            gps@amcrest.com with your IMEI number and error message.
          </p>
        </div>
        <div className="row">
          <div className="customerform_left col-lg-5">
            <h1>Let's get your device activated!</h1>
            <h2>
              Activating an Amcrest device is easy. Set aside about five
              minutes. We'll walk you through each step.{" "}
            </h2>
          </div>
          <div className="customerform_right col-lg-7">
            <ActivationTypeForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivationType;
